/*
在main.js 添加
import InputDialogPlugin from "@/plugins/inputDialog";
Vue.use(InputDialogPlugin);

使用见inputDialog
* */

import Vue from "vue";
import InputDialog from "./inputDialog.vue";
import "./styles.less";

// 创建构造器
const InputDialogConstructor = Vue.extend(InputDialog);
let instance = null;
const InputDialogPlugin = {
  install(Vue, options = {}) {
    // 全局方法
    Vue.prototype.$inputDialog = function (config = {}) {
      return new Promise((resolve, reject) => {
        // 如果已有实例，先销毁
        if (instance) {
          instance.$destroy();
          instance.$el.remove();
          instance = null;
        }

        // 创建新实例
        instance = new InputDialogConstructor({
          propsData: {
            ...options,
            ...config
          }
        });

        // 挂载实例
        instance.$mount();
        document.body.appendChild(instance.$el);

        // 添加overlay类
        instance.$el.classList.add("input-dialog-overlay");

        // 打开弹窗
        instance.open().then(value => {
          resolve(value);
          cleanup();
        }).catch(error => {
          reject(error);
          cleanup();
        });
      });
    };

    // 清理函数
    function cleanup() {
      if (instance) {
        setTimeout(() => {
          if (instance && instance.$el && instance.$el.parentNode) {
            instance.$destroy();
            instance.$el.remove();
            instance = null;
          }
        }, 300);
      }
    }

    // 注册全局组件（可选）
    Vue.component("InputDialog", InputDialog);
  }
};

// 自动安装（当Vue是全局变量时）
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(InputDialogPlugin);
}
export default InputDialogPlugin;